import { CoresAplicativoInicial } from "../models/coresAplicativoModel"
import type { CoresAplicativoModel } from "../models/coresAplicativoModel"
import { CoresAplicativoActionsTypes } from "./coresAplicativoActions"
import type { CoresAplicativoActionModel } from "./coresAplicativoActions"

export function coresAplicativoReducer(
    state: CoresAplicativoModel,
    action: CoresAplicativoActionModel
): CoresAplicativoModel {
    switch (action.type) {
        case CoresAplicativoActionsTypes.CARREGAR:
            return action.payload

        case CoresAplicativoActionsTypes.ATUALIZAR_CAMPO:
            return { ...state, [action.payload.campo]: action.payload.valor }

        case CoresAplicativoActionsTypes.RESETAR:
            return CoresAplicativoInicial

        default:
            return state
    }
}
